export const VAT_RATE = 1.2;
